import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import { Login, Register } from "@/pages/Auth";
import { About, Contact } from "@/pages/Static";
import { ShippingReturns, Privacy, Terms, FAQ } from "@/pages/Legal";
import { PaymentSuccess, PaymentCancel, OrderConfirmed } from "@/pages/Payment";
import "@/App.css";

function Layout({ children, bare }) {
  return (
    <>
      {!bare && <Header />}
      <main>{children}</main>
      {!bare && <Footer />}
      {!bare && <CartDrawer />}
      {!bare && <WhatsAppButton />}
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/shop" element={<Layout><Shop /></Layout>} />
      <Route path="/product/:id" element={<Layout><ProductDetail /></Layout>} />
      <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/shipping-returns" element={<Layout><ShippingReturns /></Layout>} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/faq" element={<Layout><FAQ /></Layout>} />
      <Route path="/login" element={<Layout bare><Login /></Layout>} />
      <Route path="/register" element={<Layout bare><Register /></Layout>} />
      <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
      <Route path="/order-confirmed" element={<Layout><OrderConfirmed /></Layout>} />
      <Route path="/account" element={<ProtectedRoute><Layout><Account /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Layout><Admin /></Layout></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRoutes />
          <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#141416", border: "1px solid rgba(212,175,55,0.3)", color: "#FAFAF7" } }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
